import React, { createContext, useContext, useEffect, useState } from "react";

const DemoModeContext = createContext({
  isDemoMode: false,
  demoCard: null,
  demoRetentionDays: 21,
});

export function DemoModeProvider({ children }) {
  const [isDemoMode, setIsDemoMode] = useState(false);
  const [demoCard, setDemoCard] = useState(null);
  // Default matches the server-side default; the API value wins when it arrives.
  const [demoRetentionDays, setDemoRetentionDays] = useState(21);

  useEffect(() => {
    const base =
      process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
    fetch(`${base}/api/platform-settings/demo-config`)
      .then((r) => r.json())
      .then((data) => {
        if (data?.isDemoMode) {
          setIsDemoMode(true);
          setDemoCard(data.demoCard || null);
          if (Number.isFinite(Number(data.demoRetentionDays))) {
            setDemoRetentionDays(Number(data.demoRetentionDays));
          }
        }
      })
      .catch(() => {
        // Non-critical — fail silently
      });
  }, []);

  return (
    <DemoModeContext.Provider
      value={{ isDemoMode, demoCard, demoRetentionDays }}
    >
      {children}
    </DemoModeContext.Provider>
  );
}

export function useDemoMode() {
  return useContext(DemoModeContext);
}
